import type { IDictionary } from '../appstate';
import type { ICustomer } from '../domain';

export interface ISession {
	customerName: string;
	customerId: number;
	customerAttributes: number[];
	userId: number;
	roles: string[];
	expiresAt: string;
	expiresIn: number;
	customerCount: number;
	userDefaultPageSize: number;
	siteTypeId: number;
	metaProductListingOptions: IMetaProductListingOptions;
	searchOptions: ISearchOptions;
	userProfile: IUserProfile;
	customer: ICustomer | null;
	externalId?: string;
}

interface IMetaProductListingOptions {
	showItemSpecificationWidget: boolean;
	showItemCoverageWidget: boolean;
	//Key = customer id
	coverageFilters: IDictionary<string[]>;
}

interface IUserProfile {
	id: number;
	description: string;
}

export interface ISearchOptions {
	showSpecItem: boolean;
	showCategories: boolean;
	showExpandedDesc: boolean;
}

const defaultSession: ISession = {
	customerName: null,
	customerId: null,
	customerAttributes: [],
	userId: null,
	roles: [],
	expiresAt: null,
	expiresIn: null,
	customerCount: null,
	userDefaultPageSize: null,
	siteTypeId: null,
	metaProductListingOptions: {
		showItemSpecificationWidget: false,
		showItemCoverageWidget: false,
		coverageFilters: {},
	},
	searchOptions: null,
	userProfile: null,
	customer: null,
};

export function setSession(session: ISession) {
	window.localStorage.setItem(
		'ogm',
		JSON.stringify({ ...defaultSession, ...session })
	);
}

export function getSession(): ISession {
	const data = window.localStorage.getItem('ogm');
	if (!data) {
		return {} as any;
	}
	return JSON.parse(data);
}
